export const RETRIEVE_RESERVATION_RESERVE_AREA = 'RETRIEVE_RESERVATION_RESERVE_AREA';
export const SET_RESERVATION_CODE_ACTION = 'SET_RESERVATION_CODE_ACTION';
export const SET_PASSENGERS_FILLED_ACTION = 'SET_PASSENGERS_FILLED_ACTION';
export const FETCH_AND_SET_EXTRAS = 'FETCH_AND_SET_EXTRAS_RESERVE_AREA';